import { render, staticRenderFns } from "./diamondList.vue?vue&type=template&id=219f9087"
import script from "./diamondList.vue?vue&type=script&lang=js"
export * from "./diamondList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219f9087')) {
      api.createRecord('219f9087', component.options)
    } else {
      api.reload('219f9087', component.options)
    }
    module.hot.accept("./diamondList.vue?vue&type=template&id=219f9087", function () {
      api.rerender('219f9087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/diamondList.vue"
export default component.exports